// @ts-nocheck
import { locationSearchFormStyles } from "@insite/content-library/Components/LocationSearchForm";
import { linkStyles } from "@store/Themes/common/mixins/link";

Object.assign(locationSearchFormStyles, {
    locationNameLink: { css: linkStyles("text.linkHover", "text.link", false, true) },
});
